import PropTypes from 'prop-types';
import {PureComponent, cloneElement} from 'react';

import {BlockShape} from '../../../lessons/shapes';

const mediaFilter = ({type}) => type === 'media';
const IDMapper = ({config}) => (typeof config === 'number' ? config : config.id);
const getMediaIDs = blocks => blocks.filter(mediaFilter).map(IDMapper);

class MediaIDCollector extends PureComponent {

    static propTypes = {
        children: PropTypes.element.isRequired,
        blocks: PropTypes.arrayOf(
            PropTypes.shape(BlockShape),
        ).isRequired,
    };

    render() {
        const {blocks, children} = this.props;
        const ids = getMediaIDs(blocks);

        return cloneElement(children, {ids});
    }
}

export default MediaIDCollector;



// WEBPACK FOOTER //
// ./scripts/frontend/questionnaires/components/DownloadButton/MediaIDCollector.js